import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { PermSetEditTargetsComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-add/perm-set-add-lines/perm-set-add-lines-edit/perm-set-add-lines-edit-targets/perm-set-edit-targets.component';
import { PermSetAddLinesEditComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-add/perm-set-add-lines/perm-set-add-lines-edit/perm-set-add-lines-edit.component';
import { PermSetAddLinesComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-add/perm-set-add-lines/perm-set-add-lines.component';
import { PermSetAddComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-add/perm-set-add.component';
import { PermSetEditLinesEditTargetsComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-edit/perm-set-edit-lines/perm-set-edit-lines-edit/perm-set-edit-lines-edit-targets/perm-set-edit-lines-edit-targets.component';
import { PermSetEditLinesEditComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-edit/perm-set-edit-lines/perm-set-edit-lines-edit/perm-set-edit-lines-edit.component';
import { PermSetEditLinesComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-edit/perm-set-edit-lines/perm-set-edit-lines.component';
import { PermSetEditComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-edit/perm-set-edit.component';
import { PermSetListingComponent } from '../permission-container/permission-set/perm-set-listing/perm-set-listing.component';
import { ViewColumn } from '../../../view-column';

@Injectable()

// This is where we need to change the view columns.
export class PermissionSetPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, PermSetListingComponent, 'Permission Set Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, PermSetListingComponent, 'Permission Set Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, PermSetAddComponent, 'Add Permission Set', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(2, PermSetEditComponent, 'Edit Permission Set', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(3, PermSetAddLinesComponent, 'Configure Permission Set Lines', {
        deactivateAdd: false,
        deactivateList: false,
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(4, PermSetAddLinesEditComponent, 'Edit Permission Set Line Details', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(5, PermSetEditTargetsComponent, 'Add Target', {
        deactivateAdd: false,
        deactivateList: false,
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(6, PermSetEditLinesComponent, 'Configure Permission Set Lines', {
        deactivateAdd: false,
        deactivateList: false,
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(7, PermSetEditLinesEditComponent, 'Edit Permisson Set Line Details', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      // This class screen is useless as it is the same as PermSetEditTargetsComponent. Can ignore.
      // new ViewColumn(8, PermSetEditLinesEditTargetsComponent, 'Add Target', {
      //   deactivateAdd: false,
      //   deactivateList: false,
      //   deactivateReturn: false,
      //   selectedIndex: 0
      // })
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
